// Takes a "YYYY-MM-DD HH:MM:SS" GMT string and return Javascript Date
export function dbsParseGmtDate(strDbsDate: string) {
  var dtReturn = null;
  if (strDbsDate) {
    // Have to do this a weird way to satify older IE8.
    strDbsDate = strDbsDate.replace(' ', 'T') + '.0+00:00';
    var regexIso8601 = /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})\.(\d{1,3})(?:Z|([-+])(\d{2}):(\d{2}))?)?)?)?$/;
    var m = regexIso8601.exec(strDbsDate) || [];
    var p: Array<number> = m.map(s => parseInt(s, 10) || 0);
    var sec = Date.UTC(
      p[1],
      p[2] - 1,
      p[3] || 1,
      p[4] - (p[8] ? p[8] + p[9] : 0) || 0,
      p[5] - (p[8] ? p[8] + p[10] : 0) || 0,
      p[6] || 0,
      parseInt(((m[7] || 0) + '00').substr(0, 3), 10)
    );
    dtReturn = new Date(sec);
  }
  return dtReturn;
}

export function formatDateNumber(nNum: number) {
  var strReturn = nNum;
  if (nNum < 10) {
    strReturn = '0' + strReturn;
  }
  return strReturn;
}

// Convert date to "YYYY-MM-DD HH:MM:SS" local browser time format.
export function formatDateLocal(date: Date) {
  return (
    date.getFullYear() +
    '-' +
    formatDateNumber(date.getMonth() + 1) +
    '-' +
    formatDateNumber(date.getDate()) +
    ' ' +
    formatDateNumber(date.getHours()) +
    ':' +
    formatDateNumber(date.getMinutes()) +
    ':' +
    formatDateNumber(date.getSeconds())
  );
}

// Parses a DoD DN with comma RDN separators and returns an object
// that has a parsed out cn (if possible) and an array for the OU's.
type ParsedDnDod = {
  cn: {
    cn: string,
    edipi?: string,
    first?: string,
    last?: string,
    middle?: string
  },
  c: string,
  o: string,
  ou: string | Array<string>
};
export function dbsParseDodDn(strDn: string): ParsedDnDod | null {
  var objReturn: ParsedDnDod | null = null;

  if (strDn) {
    objReturn = { c: '', o: '', ou: [], cn: { cn: '' } };
    var arrRdns = strDn.split(',');
    if (arrRdns.length > 2) {
      for (var nRdn = 0; nRdn < arrRdns.length; nRdn++) {
        var strRdn = arrRdns[nRdn];
        var arrParts = strRdn.split('=');
        var strComp = arrParts.shift().toLowerCase();
        var strVal = arrParts.join('=');

        if (strComp === 'ou') {
          // ou will be an array
          if (objReturn.ou) {
            objReturn.ou.push(strVal);
          } else {
            objReturn.ou = [strVal];
          }
        } else if (strComp === 'cn') {
          // cn will be an object
          var arrCn = strVal.split('.');
          if (arrCn.length === 4) {
            // if it was L.F.M.E format,
            // then parse into object
            objReturn.cn = {
              cn: strVal,
              last: arrCn[0],
              first: arrCn[1],
              middle: arrCn[2],
              edipi: arrCn[3]
            };
          } else {
            // probably just a CA name or something
            // so just put it in cn
            objReturn.cn = {
              cn: strVal
            };
          }
        } else {
          objReturn[strComp] = strVal;
        }
      }
    }
  }

  return objReturn;
}
